export default __webpack_public_path__ + "static/19.Pentecost-962acadc51d37e23daaf6123f10f84eb.png";